<template>
  <div class="bursary-application-page">
    <main-navigation></main-navigation>
    
    <div class="page-container">
      <!-- Compact Header -->
      <div class="compact-header">
        <h1 class="page-title">
          <span>2025/26 NORTH MUGIRANGO</span>
          <span>BURSARY APPLICATION</span>
        </h1>
        <div class="deadline-badge">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
          </svg>
          <span>Deadline: <strong>16th Jan 2026</strong></span>
        </div>
      </div>

      <!-- Main Content Grid -->
      <div class="content-grid">
        <!-- Left Column: Instructions -->
        <div class="left-column">
          <base-card class="instructions-card">
            <div class="card-header">
              <h2>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                </svg>
                Application Instructions
              </h2>
            </div>
            
            <div class="card-body">
              <!-- Critical Warning -->
              <div class="warning-box">
                <div class="warning-icon">!</div>
                <div class="warning-content">
                  <strong>IMPORTANT:</strong> When entering school name, type and select from dropdown. Don't type manually if school is listed. Missing schools? Contact us on 0725029795 immediately.
                </div>
              </div>

              <!-- Quick Instructions -->
              <div class="quick-instructions">
                <h3>Quick Guide:</h3>
                <ul>
                  <li><strong>Complete all fields</strong> accurately - incomplete forms may be disqualified</li>
                  <li><strong>High school</strong> forms must be filled by parents/guardians</li>
                  <li><strong>Provide ID</strong>: Birth certificate (high school) or National ID (college/university)</li>
                  <li><strong>Get verified</strong> by local chief/assistant chief after filling</li>
                  <li><strong>Submit to Designated collection centers within your ward</strong> before deadline</li>
                </ul>
              </div>

              <!-- Required Documents -->
              <div class="documents-section">
                <h3>Required Documents:</h3>
                <div class="documents-list">
                  <span class="document-tag">Student's transcript/report</span>
                  <span class="document-tag">Parent/guardian ID copy</span>
                  <span class="document-tag">Student ID/Birth certificate</span>
                  <span class="document-tag">Admission letter</span>
                </div>
              </div>

              <!-- Already Applied -->
              <div class="already-applied">
                <p>Already applied?</p>
                <router-link to="/application/form/" class="download-btn">
                  Download Your Form
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                </router-link>
              </div>
            </div>
          </base-card>
        </div>

        <!-- Right Column: Application Links -->
        <div class="right-column">
          <base-card class="application-card">
            <div class="card-header">
              <h2>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
                </svg>
                Start Application
              </h2>
            </div>

            <div class="card-body">
              <p class="application-subtitle">Select your education level to begin:</p>
              
              <div class="application-options">
                <router-link to="/secondary/application" class="app-option secondary">
                  <div class="option-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                    </svg>
                  </div>
                  <div class="option-content">
                    <h3>Secondary School</h3>
                    <p>For high school students (Forms 3 and 4)</p>
                  </div>
                  <div class="option-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                  </div>
                </router-link>

                <router-link to="/college/application" class="app-option college">
                  <div class="option-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                    </svg>
                  </div>
                  <div class="option-content">
                    <h3>Universities & Colleges</h3>
                    <p>For tertiary institution students</p>
                  </div>
                  <div class="option-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                  </div>
                </router-link>

                <router-link to="/" class="app-option home">
                  <div class="option-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                    </svg>
                  </div>
                  <div class="option-content">
                    <h3>Back to Home</h3>
                    <p>Return to homepage</p>
                  </div>
                  <div class="option-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <!-- Quick Info Box -->
              <div class="info-box">
                <h4>Submission Details:</h4>
                <div class="info-content">
                  <p><strong>Where:</strong> Designated centers within your ward</p>
                  <p><strong>When:</strong> On or before 16th January 2026</p>
                  <p><strong>Bring:</strong> All required documents + stamped form</p>
                </div>
              </div>
            </div>
          </base-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      user: "",
      formData: {
        student_names: "",
        student_id: "",
        student_phone: "",
        student_date_of_birth: "",
        student_admission_number: "",
        year_of_admission: "",
        annual_fee: "",
        campus_name: "",
        mode_of_study: "",
        sub_location: "",
        course_of_study: "",
        mother_names: "",
        mother_id: "",
        mother_phone: "",
        father_names: "",
        father_id: "",
        father_phone: "",
        Guardian_names: "",
        Guardian_id: "",
        guardian_phone: "",
        school_name: "",
        school_level: "",
        needy_status: "",
        ward: "",
      },
    };
  },
  methods: {
    async createStudent() {
      const response = await axios.post(
        "https://api.roberms.com/nyamoko/student/registration",
        this.formData
      );
      console.log(response);
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
/* Base styles */
.bursary-application-page {
  min-height: 100vh;
  background: #f8fafc;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Compact Header */
.compact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e2e8f0;
}

.page-title {
  margin: 0;
  font-size: 1.6rem;
  color: #1e293b;
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.page-title span:first-child {
  font-weight: 700;
  color: #1a2980;
}

.page-title span:last-child {
  font-weight: 600;
  color: #475569;
  font-size: 1.3rem;
}

.deadline-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fee2e2;
  color: #991b1b;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.deadline-badge svg {
  width: 18px;
  height: 18px;
}

/* Content Grid */
.content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}

@media (max-width: 900px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

/* Card Styles */
.instructions-card,
.application-card {
  height: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  background: white;
}

.card-header {
  background: #f1f5f9;
  padding: 18px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header svg {
  width: 22px;
  height: 22px;
  color: #475569;
}

.card-body {
  padding: 24px;
}

/* Warning Box */
.warning-box {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-left: 4px solid #f97316;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
}

.warning-icon {
  background: #f97316;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
  font-size: 0.9rem;
}

.warning-content {
  flex: 1;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* Quick Instructions */
.quick-instructions {
  margin-bottom: 25px;
}

.quick-instructions h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.15rem;
  color: #334155;
}

.quick-instructions ul {
  margin: 0;
  padding-left: 20px;
}

.quick-instructions li {
  margin-bottom: 8px;
  line-height: 1.5;
  font-size: 0.95rem;
  color: #475569;
}

/* Documents Section */
.documents-section h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.15rem;
  color: #334155;
}

.documents-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 25px;
}

.document-tag {
  background: #e0f2fe;
  color: #0369a1;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid #bae6fd;
}

/* Already Applied */
.already-applied {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0fdf4;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #bbf7d0;
}

.already-applied p {
  margin: 0;
  font-weight: 500;
  color: #166534;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #16a34a;
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.2s;
}

.download-btn:hover {
  background: #15803d;
}

.download-btn svg {
  width: 18px;
  height: 18px;
}

/* Application Options */
.application-subtitle {
  margin-top: 0;
  margin-bottom: 20px;
  color: #64748b;
  font-size: 0.95rem;
}

.application-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
}

.app-option {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 18px;
  text-decoration: none;
  color: inherit;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  transition: all 0.2s;
  background: white;
}

.app-option:hover {
  border-color: #3b82f6;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.option-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.secondary .option-icon {
  background: linear-gradient(135deg, #1a2980 0%, #26d0ce 100%);
}

.college .option-icon {
  background: linear-gradient(135deg, #26d0ce 0%, #1a2980 100%);
}

.home .option-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.option-icon svg {
  width: 24px;
  height: 24px;
  color: white;
}

.option-content {
  flex: 1;
}

.option-content h3 {
  margin: 0 0 4px 0;
  font-size: 1.1rem;
  color: #1e293b;
}

.option-content p {
  margin: 0;
  font-size: 0.9rem;
  color: #64748b;
}

.option-arrow svg {
  width: 20px;
  height: 20px;
  color: #94a3b8;
  transition: transform 0.2s;
}

.app-option:hover .option-arrow svg {
  color: #3b82f6;
  transform: translateX(3px);
}

/* Info Box */
.info-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 18px;
}

.info-box h4 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.1rem;
  color: #334155;
}

.info-content p {
  margin: 8px 0;
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.5;
}

.info-content strong {
  color: #1e293b;
}

/* Scrollbar styling */
.content-grid::-webkit-scrollbar {
  width: 6px;
}

.content-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.content-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.content-grid::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .compact-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .page-title {
    font-size: 1.4rem;
  }
  
  .content-grid {
    max-height: none;
    overflow-y: visible;
  }
  
  .already-applied {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  
  .documents-list {
    justify-content: center;
  }
}
</style>